import React, { useState, useEffect } from "react";
import { ReactComponent as Bell } from "../../../assets/svgs/bell.svg";
import { useAuthContext } from "../../../context/AuthContext";
import Dropdown from "./Dropdown";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import { ReactComponent as SideArrow } from "../../../assets/svgs/sideArrow.svg";
import { unSeenNotificationCount } from "../../../utils/api/unSeenNotificationCount";
import NotificationList from "../NotificationList/index";
import { getProjectDetails } from "../../../utils/api/getProjectDetails";
import { Skeleton } from "antd";

const extractFirstSegment = (pathname) => {
  const segments = pathname.split("/");
  return { first: segments[1] || null, rest: segments.slice(2) };
};

const getSettingTitle = {
  roles: "Roles & Responsibilities",
  users: "User List"
};
const getHeading = (key, params, navigate, pathname, projectName, loading) => {
  if (loading) {
    return <Skeleton.Input style={{ width: 500, height: 40 }} active />;
  }

  const style = {
    "/": (
      <h1 className="text-xl tracking-wider">
        Welcome to <b>Admin dashboard</b>
      </h1>
    ),
    "user-login": <h1 className="capitalize text-3xl font-bold">User Login</h1>,
    projects: <h1 className="capitalize text-3xl font-bold">Projects</h1>,
    "marketplace-users": (
      <h1 className="capitalize text-3xl font-bold">Marketplace Users</h1>
    ),
    "user-profile": (
      <h1 className="capitalize text-3xl font-bold">User Profile</h1>
    ),
    "transfer-requests": (
      <h1 className="capitalize text-3xl font-bold">Transfer Request</h1>
    ),
    "transfer-details": (
      <div
        className="flex"
        onClick={() => navigate(-1)}
        style={{ cursor: "pointer" }}
      >
        <SideArrow className="w-10 h-10" />
        <h1 className="capitalize text-3xl pl-4 font-bold">Transfer Details</h1>
      </div>
    ),
    "token-history": (
      <h1 className="capitalize text-3xl font-bold">Token History</h1>
    ),
    tokenTrail: (
      <h1 className="capitalize text-3xl font-bold">Token History</h1>
    ),
    transactions: (
      <h1 className="capitalize text-3xl font-bold">Transactions</h1>
    ),
    "transaction-details": (
      <div
        className="flex"
        onClick={() => navigate(-1)}
        style={{ cursor: "pointer" }}
      >
        <SideArrow className="w-10 h-10" />
        <h1 className="capitalize text-3xl pl-4 font-bold">
          Transaction Details
        </h1>
      </div>
    ),
    retirements: (
      <h1 className=" capitalize text-3xl font-bold">Retirements</h1>
    ),
    "news-and-blogs": (
      <h1 className=" capitalize text-3xl font-bold">News and Blogs</h1>
    ),
    "all-news": (
      <div
        className="flex"
        onClick={() => navigate(-1)}
        style={{ cursor: "pointer" }}
      >
        <SideArrow className="w-10 h-10 " />
        <h1 className=" capitalize text-3xl pl-4 font-bold">All News</h1>
      </div>
    ),
    "all-blogs": (
      <div
        className="flex"
        onClick={() => navigate(-1)}
        style={{ cursor: "pointer" }}
      >
        <SideArrow className="w-10 h-10 " />
        <h1 className=" capitalize text-3xl pl-4 font-bold">All Blogs</h1>
      </div>
    ),
    "retirement-details": (
      <div
        className="flex"
        onClick={() => navigate(-1)}
        style={{ cursor: "pointer" }}
      >
        <SideArrow className="w-10 h-10 " />
        <h1 className="capitalize text-3xl pl-4 font-bold">
          Retirement Details
        </h1>
      </div>
    ),
    "news-description": (
      <div
        className="flex"
        onClick={() => navigate(-1)}
        style={{ cursor: "pointer" }}
      >
        <SideArrow className="w-10 h-10 " />
        <h1 className="capitalize text-3xl pl-4 font-bold">News</h1>
      </div>
    ),
    "blogs-description": (
      <div
        className="flex"
        onClick={() => navigate(-1)}
        style={{ cursor: "pointer" }}
      >
        <SideArrow className="w-10 h-10 " />
        <h1 className="capitalize text-3xl pl-4 font-bold">Blogs</h1>
      </div>
    ),
    "setting/static-pages": (
      <h1 className="capitalize text-3xl font-bold">Pages</h1>
    ),
    "user-kyc": <h1 className="capitalize text-3xl font-bold">KYC</h1>,
    "userkyc-details": (
      <div
        className="flex"
        onClick={() => navigate(-1)}
        style={{ cursor: "pointer" }}
      >
        <SideArrow className="w-10 h-10 " />
        <h1 className="capitalize text-3xl font-bold pl-4 ">KYC </h1>{" "}
      </div>
    ),

    "marketplace-user": (
      <div
        className="flex"
        onClick={() => navigate(-1)}
        style={{ cursor: "pointer" }}
      >
        <SideArrow className="w-10 h-10 " />
        <h1 className="capitalize text-3xl pl-4 font-bold">User</h1>
      </div>
    ),
    coupons: <h1 className="capitalize text-3xl font-bold">Coupons</h1>,
    reports: (
      <h1 className="text-2xl font-normal">
        Welcome to <span className="font-bold">Reports</span>
      </h1>
    ),
    "wallet-manage": (
      <h1 className="capitalize text-3xl font-bold">Deposit/Withdraw</h1>
    ),
    "deposit-withdraw-details": (
      <div
        className="flex"
        onClick={() => navigate(-1)}
        style={{ cursor: "pointer" }}
      >
        <SideArrow className="w-10 h-10 " />
        <h1 className="capitalize text-3xl pl-4 font-bold">Deposit/Withdraw</h1>
      </div>
    ),
    "account-details": (
      <div
        className="flex"
        onClick={() => navigate(-1)}
        style={{ cursor: "pointer" }}
      >
        <SideArrow className="w-10 h-10 " />
        <h1 className="capitalize text-3xl pl-4 font-bold">Account details</h1>
      </div>
    ),
    "contact-us": (
      <div
        className="flex"
        onClick={() => navigate(-1)}
        style={{ cursor: "pointer" }}
      >
        <SideArrow className="w-10 h-10 " />
        <h1 className="capitalize text-3xl pl-4 font-bold">Contact Us</h1>
      </div>
    )
  };

  if (pathname === "/wallet-manage/Deposit-Withdraw") {
    return <h1 className="capitalize text-3xl font-bold">Deposit/Withdraw</h1>;
  } else if (pathname === "/wallet-manage/account-management") {
    return (
      <h1 className="capitalize text-3xl font-bold">Account Management</h1>
    );
  } else if (pathname === "/forms/contact-us") {
    return <h1 className="capitalize text-3xl font-bold">Contact Us</h1>;
  } else if (pathname === "/forms/inquire") {
    return <h1 className="capitalize text-3xl font-bold">Inquire</h1>;
  } else if (pathname === "/forms/subscription") {
    return <h1 className="capitalize text-3xl font-bold">Subscription</h1>;
  } else if (pathname === "/setting/roles") {
    return <h1 className="capitalize text-3xl font-bold">Roles</h1>;
  } else if (pathname === "/setting/users") {
    return <h1 className="capitalize text-3xl font-bold">User List</h1>;
  } else if (pathname === "/setting/offsetgo-details") {
    return <h1 className="capitalize text-3xl font-bold">OffsetGo Details</h1>;
  } else if (pathname === "/setting/dashboard") {
    return (
      <h1 className="capitalize text-3xl font-bold"> Dashboard Management</h1>
    );
  } else if (pathname === "/setting/static-pages") {
    return <h1 className="capitalize text-3xl font-bold">Pages</h1>;
  } else if (pathname === "/setting/static-pages/EditStaticPage") {
    return (
      <>
        <div
          className="flex"
          onClick={() => navigate(-1)}
          style={{ cursor: "pointer" }}
        >
          <SideArrow className="w-10 h-10 " />
          <h1 className="capitalize pl-3 text-3xl font-bold">
            Static Pages
          </h1>{" "}
        </div>
        ;
      </>
    );
  } else if (pathname.startsWith("/project/") && projectName) {
    return <h1 className="capitalize text-3xl font-bold">{projectName}</h1>;
  }

  return style[key];
};
const Header = () => {
  const { authUser } = useAuthContext();
  const location = useLocation();
  const currentLocation =
    location.pathname === "/"
      ? "/"
      : extractFirstSegment(location.pathname).first;
  const params = useParams();
  const navigate = useNavigate();
  const [notificationClick, setNotificationClick] = useState(false);
  const [unSeenNotification, setUnSeenNotification] = useState({});
  const [projectName, setProjectName] = useState("");
  const [loading, setLoading] = useState(true);

  const fetchData = async () => {
    try {
      const response = await unSeenNotificationCount(authUser);
      setUnSeenNotification(response.data.count);
    } catch (error) {
      console.log("Error is : ", error);
    }
  };

  useEffect(() => {
    const { pathname } = location;
    const projectId = pathname.split("/")[2];
    if (pathname.startsWith("/project/") && projectId) {
      const fetchProjectName = async () => {
        setLoading(true);
        try {
          const project = await getProjectDetails(projectId);
          setProjectName(project.project_name || "Project Details");
        } catch (error) {
          console.log("Error fetching project details:", error);
          setProjectName("Project Details");
        } finally {
          setLoading(false);
        }
      };
      fetchProjectName();
    } else {
      setProjectName("");
      setLoading(false);
    }
  }, [location]);

  const handleNotificationClick = () => {
    setNotificationClick((prevState) => !prevState);
  };

  const handlecloseNotification = () => {
    fetchData();
    setNotificationClick(false);
  };

  useEffect(() => {
    const intervalId = setInterval(fetchData, 30000);
    return () => clearInterval(intervalId);
  }, [notificationClick]);

  return (
    <header className="flex justify-between pl-6 pr-4 py-2">
      {getHeading(
        currentLocation,
        params,
        navigate,
        location.pathname,
        projectName,
        loading
      )}
      <div className="flex items-center gap-x-6 relative">
        <div className="relative" onClick={handleNotificationClick}>
          <Bell className="w-6" />
          {unSeenNotification > 0 && (
            <div className="absolute top-0 right-0 bg-red-500 text-white rounded-full w-3 h- flex items-center justify-center text-[10px]">
              {unSeenNotification}
            </div>
          )}
        </div>
        {notificationClick && (
          <NotificationList
            onClose={handlecloseNotification}
            unSeenNotification={unSeenNotification}
          />
        )}
        <h2 className="text-2xl font-normal tracking-wider capitalize">
          {authUser.name}
        </h2>
        <Dropdown />
      </div>
    </header>
  );
};

export default Header;
